"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ed5 = require("xmlchars/xml/1.0/ed5");

var ed2 = require("xmlchars/xml/1.1/ed2");

var NSed3 = require("xmlchars/xmlns/1.0/ed3");

var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
var rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
var XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
}; // EOC: end-of-chunk

var EOC = -1;
var NL_LIKE = -2;
var S_BEGIN = 0; // Initial state.

var S_BEGIN_WHITESPACE = 1; // leading whitespace

var S_DOCTYPE = 2; // <!DOCTYPE

var S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah

var S_DTD = 4; // <!DOCTYPE "//blah" [ ...

var S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo

var S_DTD_OPEN_WAKA = 6;
var S_DTD_OPEN_WAKA_BANG = 7;
var S_DTD_COMMENT = 8; // <!--

var S_DTD_COMMENT_ENDING = 9; // <!-- blah -

var S_DTD_COMMENT_ENDED = 10; // <!-- blah --

var S_DTD_PI = 11; // <?

var S_DTD_PI_ENDING = 12; // <?hi "there" ?

var S_TEXT = 13; // general stuff

var S_ENTITY = 14; // &amp and such

var S_OPEN_WAKA = 15; // <

var S_OPEN_WAKA_BANG = 16; // <!...

var S_COMMENT = 17; // <!--

var S_COMMENT_ENDING = 18; // <!-- blah -

var S_COMMENT_ENDED = 19; // <!-- blah --

var S_CDATA = 20; // <![CDATA[ something

var S_CDATA_ENDING = 21; // ]

var S_CDATA_ENDING_2 = 22; // ]]

var S_PI_FIRST_CHAR = 23; // <?hi, first char

var S_PI_REST = 24; // <?hi, rest of the name

var S_PI_BODY = 25; // <?hi there

var S_PI_ENDING = 26; // <?hi "there" ?

var S_XML_DECL_NAME_START = 27; // <?xml

var S_XML_DECL_NAME = 28; // <?xml foo

var S_XML_DECL_EQ = 29; // <?xml foo=

var S_XML_DECL_VALUE_START = 30; // <?xml foo=

var S_XML_DECL_VALUE = 31; // <?xml foo="bar"

var S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"

var S_XML_DECL_ENDING = 33; // <?xml ... ?

var S_OPEN_TAG = 34; // <strong

var S_OPEN_TAG_SLASH = 35; // <strong /

var S_ATTRIB = 36; // <a

var S_ATTRIB_NAME = 37; // <a foo

var S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _

var S_ATTRIB_VALUE = 39; // <a foo=

var S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar

var S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"

var S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar

var S_CLOSE_TAG = 43; // </a

var S_CLOSE_TAG_SAW_WHITE = 44; // </a   >

var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
var BANG = 0x21;
var DQUOTE = 0x22;
var AMP = 0x26;
var SQUOTE = 0x27;
var MINUS = 0x2D;
var FORWARD_SLASH = 0x2F;
var SEMICOLON = 0x3B;
var LESS = 0x3C;
var EQUAL = 0x3D;
var GREATER = 0x3E;
var QUESTION = 0x3F;
var OPEN_BRACKET = 0x5B;
var CLOSE_BRACKET = 0x5D;
var NEL = 0x85;
var LS = 0x2028; // Line Separator

var isQuote = function isQuote(c) {
  return c === DQUOTE || c === SQUOTE;
};

var QUOTES = [DQUOTE, SQUOTE];
var DOCTYPE_TERMINATOR = [].concat(QUOTES, [OPEN_BRACKET, GREATER]);
var DTD_TERMINATOR = [].concat(QUOTES, [LESS, CLOSE_BRACKET]);
var XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION].concat(_toConsumableArray(S_LIST));
var ATTRIB_VALUE_UNQUOTED_TERMINATOR = [].concat(_toConsumableArray(S_LIST), [GREATER, AMP, LESS]);

function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail("xml prefix must be bound to ".concat(XML_NAMESPACE, "."));
      }

      break;

    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail("xmlns prefix must be bound to ".concat(XMLNS_NAMESPACE, "."));
      }

      break;

    default:
  }

  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : "may not assign a prefix (even \"xmlns\") to the URI ".concat(XMLNS_NAMESPACE, "."));
      break;

    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;

        case "":
          parser.fail("the default namespace may not be set to ".concat(uri, "."));
          break;

        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }

      break;

    default:
  }
}

function nsMappingCheck(parser, mapping) {
  for (var _i = 0, _Object$keys = Object.keys(mapping); _i < _Object$keys.length; _i++) {
    var local = _Object$keys[_i];
    nsPairCheck(parser, local, mapping[local]);
  }
}

var isNCName = function isNCName(name) {
  return NC_NAME_RE.test(name);
};

var isName = function isName(name) {
  return NAME_RE.test(name);
};

var FORBIDDEN_START = 0;
var FORBIDDEN_BRACKET = 1;
var FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */

exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
var EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};

var SaxesParser = /*#__PURE__*/function () {
  /**
   * @param opt The parser options.
   */
  function SaxesParser(opt) {
    _classCallCheck(this, SaxesParser);

    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    var xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;

    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.processAttribs = this.processAttribsNS; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.pushAttrib = this.pushAttribNS; // eslint-disable-next-line @typescript-eslint/no-explicit-any

      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      var additional = this.opt.additionalNamespaces;

      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.processAttribs = this.processAttribsPlain; // eslint-disable-next-line @typescript-eslint/unbound-method

      this.pushAttrib = this.pushAttribPlain;
    } //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //


    this.stateTable = [
    /* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];

    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */


  _createClass(SaxesParser, [{
    key: "_init",
    value: function _init() {
      var _a;

      this.openWakaBang = "";
      this.text = "";
      this.name = "";
      this.piTarget = "";
      this.entity = "";
      this.q = null;
      this.tags = [];
      this.tag = null;
      this.topNS = null;
      this.chunk = "";
      this.chunkPosition = 0;
      this.i = 0;
      this.prevI = 0;
      this.carriedFromPrevious = undefined;
      this.forbiddenState = FORBIDDEN_START;
      this.attribList = []; // The logic is organized so as to minimize the need to check
      // this.opt.fragment while parsing.

      var fragmentOpt = this.fragmentOpt;
      this.state = fragmentOpt ? S_TEXT : S_BEGIN; // We want these to be all true if we are dealing with a fragment.

      this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt; // An XML declaration is intially possible only when parsing whole
      // documents.

      this.xmlDeclPossible = !fragmentOpt;
      this.xmlDeclExpects = ["version"];
      this.entityReturnState = undefined;
      var defaultXMLVersion = this.opt.defaultXMLVersion;

      if (defaultXMLVersion === undefined) {
        if (this.opt.forceXMLVersion === true) {
          throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
        }

        defaultXMLVersion = "1.0";
      }

      this.setXMLVersion(defaultXMLVersion);
      this.positionAtNewLine = 0;
      this.doctype = false;
      this._closed = false;
      this.xmlDecl = {
        version: undefined,
        encoding: undefined,
        standalone: undefined
      };
      this.line = 1;
      this.column = 0;
      this.ENTITIES = Object.create(XML_ENTITIES); // eslint-disable-next-line no-unused-expressions

      (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */

  }, {
    key: "on",

    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */
    value: function on(name, handler) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */

  }, {
    key: "off",
    value: function off(name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */

  }, {
    key: "makeError",
    value: function makeError(message) {
      var _a;

      var msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";

      if (this.trackPosition) {
        if (msg.length > 0) {
          msg += ":";
        }

        msg += "".concat(this.line, ":").concat(this.column);
      }

      if (msg.length > 0) {
        msg += ": ";
      }

      return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */

  }, {
    key: "fail",
    value: function fail(message) {
      var err = this.makeError(message);
      var handler = this.errorHandler;

      if (handler === undefined) {
        throw err;
      } else {
        handler(err);
      }

      return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */

  }, {
    key: "write",
    value: function write(chunk) {
      if (this.closed) {
        return this.fail("cannot write after close; assign an onready handler.");
      }

      var end = false;

      if (chunk === null) {
        // We cannot return immediately because carriedFromPrevious may need
        // processing.
        end = true;
        chunk = "";
      } else if (_typeof(chunk) === "object") {
        chunk = chunk.toString();
      } // We checked if performing a pre-decomposition of the string into an array
      // of single complete characters (``Array.from(chunk)``) would be faster
      // than the current repeated calls to ``charCodeAt``. As of August 2018, it
      // isn't. (There may be Node-specific code that would perform faster than
      // ``Array.from`` but don't want to be dependent on Node.)


      if (this.carriedFromPrevious !== undefined) {
        // The previous chunk had char we must carry over.
        chunk = "".concat(this.carriedFromPrevious).concat(chunk);
        this.carriedFromPrevious = undefined;
      }

      var limit = chunk.length;
      var lastCode = chunk.charCodeAt(limit - 1);

      if (!end && ( // A trailing CR or surrogate must be carried over to the next
      // chunk.
      lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
        // The chunk ends with a character that must be carried over. We cannot
        // know how to handle it until we get the next chunk or the end of the
        // stream. So save it for later.
        this.carriedFromPrevious = chunk[limit - 1];
        limit--;
        chunk = chunk.slice(0, limit);
      }

      var stateTable = this.stateTable;
      this.chunk = chunk;
      this.i = 0;

      while (this.i < limit) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        stateTable[this.state].call(this);
      }

      this.chunkPosition += limit;
      return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */

  }, {
    key: "close",
    value: function close() {
      return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */

  }, {
    key: "getCode10",
    value: function getCode10() {
      var chunk = this.chunk,
          i = this.i;
      this.prevI = i; // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.

      this.i = i + 1;

      if (i >= chunk.length) {
        return EOC;
      } // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.


      var code = chunk.charCodeAt(i);
      this.column++;

      if (code < 0xD800) {
        if (code >= SPACE || code === TAB) {
          return code;
        }

        switch (code) {
          case NL:
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;

          case CR:
            // We may get NaN if we read past the end of the chunk, which is fine.
            if (chunk.charCodeAt(i + 1) === NL) {
              // A \r\n sequence is converted to \n so we have to skip over the
              // next character. We already know it has a size of 1 so ++ is fine
              // here.
              this.i = i + 2;
            } // Otherwise, a \r is just converted to \n, so we don't have to skip
            // ahead.
            // In either case, \r becomes \n.


            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;

          default:
            // If we get here, then code < SPACE and it is not NL CR or TAB.
            this.fail("disallowed character.");
            return code;
        }
      }

      if (code > 0xDBFF) {
        // This is a specialized version of isChar10 that takes into account
        // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
        // test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }

        return code;
      }

      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2; // This is a specialized version of isChar10 that takes into account that in
      // this context necessarily final >= 0x10000.

      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }

      return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */

  }, {
    key: "getCode11",
    value: function getCode11() {
      var chunk = this.chunk,
          i = this.i;
      this.prevI = i; // Yes, we do this instead of doing this.i++. Doing it this way, we do not
      // read this.i again, which is a bit faster.

      this.i = i + 1;

      if (i >= chunk.length) {
        return EOC;
      } // Using charCodeAt and handling the surrogates ourselves is faster
      // than using codePointAt.


      var code = chunk.charCodeAt(i);
      this.column++;

      if (code < 0xD800) {
        if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
          return code;
        }

        switch (code) {
          case NL:
            // 0xA
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL;

          case CR:
            {
              // 0xD
              // We may get NaN if we read past the end of the chunk, which is
              // fine.
              var next = chunk.charCodeAt(i + 1);

              if (next === NL || next === NEL) {
                // A CR NL or CR NEL sequence is converted to NL so we have to skip
                // over the next character. We already know it has a size of 1.
                this.i = i + 2;
              } // Otherwise, a CR is just converted to NL, no skip.

            }

          /* yes, fall through */

          case NEL: // 0x85

          case LS:
            // Ox2028
            this.line++;
            this.column = 0;
            this.positionAtNewLine = this.position;
            return NL_LIKE;

          default:
            this.fail("disallowed character.");
            return code;
        }
      }

      if (code > 0xDBFF) {
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
        // does not test cases that don't need testing.
        if (!(code >= 0xE000 && code <= 0xFFFD)) {
          this.fail("disallowed character.");
        }

        return code;
      }

      var final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
      this.i = i + 2; // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context necessarily final >= 0x10000.

      if (final > 0x10FFFF) {
        this.fail("disallowed character.");
      }

      return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */

  }, {
    key: "getCodeNorm",
    value: function getCodeNorm() {
      var c = this.getCode();
      return c === NL_LIKE ? NL : c;
    }
  }, {
    key: "unget",
    value: function unget() {
      this.i = this.prevI;
      this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */

  }, {
    key: "captureTo",
    value: function captureTo(chars) {
      var start = this.i;
      var chunk = this.chunk; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCode();
        var isNLLike = c === NL_LIKE;
        var final = isNLLike ? NL : c;

        if (final === EOC || chars.includes(final)) {
          this.text += chunk.slice(start, this.prevI);
          return final;
        }

        if (isNLLike) {
          this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
        }
      }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */

  }, {
    key: "captureToChar",
    value: function captureToChar(char) {
      var start = this.i;
      var chunk = this.chunk; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCode();

        switch (c) {
          case NL_LIKE:
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            c = NL;
            break;

          case EOC:
            this.text += chunk.slice(start);
            return false;

          default:
        }

        if (c === char) {
          this.text += chunk.slice(start, this.prevI);
          return true;
        }
      }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */

  }, {
    key: "captureNameChars",
    value: function captureNameChars() {
      var chunk = this.chunk,
          start = this.i; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCode();

        if (c === EOC) {
          this.name += chunk.slice(start);
          return EOC;
        } // NL is not a name char so we don't have to test specifically for it.


        if (!isNameChar(c)) {
          this.name += chunk.slice(start, this.prevI);
          return c === NL_LIKE ? NL : c;
        }
      }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */

  }, {
    key: "skipSpaces",
    value: function skipSpaces() {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var c = this.getCodeNorm();

        if (c === EOC || !isS(c)) {
          return c;
        }
      }
    }
  }, {
    key: "setXMLVersion",
    value: function setXMLVersion(version) {
      this.currentXMLVersion = version;
      /*  eslint-disable @typescript-eslint/unbound-method */

      if (version === "1.0") {
        this.isChar = isChar10;
        this.getCode = this.getCode10;
      } else {
        this.isChar = isChar11;
        this.getCode = this.getCode11;
      }
      /* eslint-enable @typescript-eslint/unbound-method */

    } // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.

  }, {
    key: "sBegin",
    value: function sBegin() {
      // We are essentially peeking at the first character of the chunk. Since
      // S_BEGIN can be in effect only when we start working on the first chunk,
      // the index at which we must look is necessarily 0. Note also that the
      // following test does not depend on decoding surrogates.
      // If the initial character is 0xFEFF, ignore it.
      if (this.chunk.charCodeAt(0) === 0xFEFF) {
        this.i++;
        this.column++;
      }

      this.state = S_BEGIN_WHITESPACE;
    }
  }, {
    key: "sBeginWhitespace",
    value: function sBeginWhitespace() {
      // We need to know whether we've encountered spaces or not because as soon
      // as we run into a space, an XML declaration is no longer possible. Rather
      // than slow down skipSpaces even in places where we don't care whether it
      // skipped anything or not, we check whether prevI is equal to the value of
      // i from before we skip spaces.
      var iBefore = this.i;
      var c = this.skipSpaces();

      if (this.prevI !== iBefore) {
        this.xmlDeclPossible = false;
      }

      switch (c) {
        case LESS:
          this.state = S_OPEN_WAKA; // We could naively call closeText but in this state, it is not normal
          // to have text be filled with any data.

          if (this.text.length !== 0) {
            throw new Error("no-empty text at start");
          }

          break;

        case EOC:
          break;

        default:
          this.unget();
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }, {
    key: "sDoctype",
    value: function sDoctype() {
      var _a;

      var c = this.captureTo(DOCTYPE_TERMINATOR);

      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            this.doctype = true; // just remember that we saw it.

            break;
          }

        case EOC:
          break;

        default:
          this.text += String.fromCodePoint(c);

          if (c === OPEN_BRACKET) {
            this.state = S_DTD;
          } else if (isQuote(c)) {
            this.state = S_DOCTYPE_QUOTE;
            this.q = c;
          }

      }
    }
  }, {
    key: "sDoctypeQuote",
    value: function sDoctypeQuote() {
      var q = this.q;

      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.q = null;
        this.state = S_DOCTYPE;
      }
    }
  }, {
    key: "sDTD",
    value: function sDTD() {
      var c = this.captureTo(DTD_TERMINATOR);

      if (c === EOC) {
        return;
      }

      this.text += String.fromCodePoint(c);

      if (c === CLOSE_BRACKET) {
        this.state = S_DOCTYPE;
      } else if (c === LESS) {
        this.state = S_DTD_OPEN_WAKA;
      } else if (isQuote(c)) {
        this.state = S_DTD_QUOTED;
        this.q = c;
      }
    }
  }, {
    key: "sDTDQuoted",
    value: function sDTDQuoted() {
      var q = this.q;

      if (this.captureToChar(q)) {
        this.text += String.fromCodePoint(q);
        this.state = S_DTD;
        this.q = null;
      }
    }
  }, {
    key: "sDTDOpenWaka",
    value: function sDTDOpenWaka() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);

      switch (c) {
        case BANG:
          this.state = S_DTD_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          break;

        case QUESTION:
          this.state = S_DTD_PI;
          break;

        default:
          this.state = S_DTD;
      }
    }
  }, {
    key: "sDTDOpenWakaBang",
    value: function sDTDOpenWakaBang() {
      var char = String.fromCodePoint(this.getCodeNorm());
      var owb = this.openWakaBang += char;
      this.text += char;

      if (owb !== "-") {
        this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
        this.openWakaBang = "";
      }
    }
  }, {
    key: "sDTDComment",
    value: function sDTDComment() {
      if (this.captureToChar(MINUS)) {
        this.text += "-";
        this.state = S_DTD_COMMENT_ENDING;
      }
    }
  }, {
    key: "sDTDCommentEnding",
    value: function sDTDCommentEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);
      this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
    }
  }, {
    key: "sDTDCommentEnded",
    value: function sDTDCommentEnded() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);

      if (c === GREATER) {
        this.state = S_DTD;
      } else {
        this.fail("malformed comment."); // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "

        this.state = S_DTD_COMMENT;
      }
    }
  }, {
    key: "sDTDPI",
    value: function sDTDPI() {
      if (this.captureToChar(QUESTION)) {
        this.text += "?";
        this.state = S_DTD_PI_ENDING;
      }
    }
  }, {
    key: "sDTDPIEnding",
    value: function sDTDPIEnding() {
      var c = this.getCodeNorm();
      this.text += String.fromCodePoint(c);

      if (c === GREATER) {
        this.state = S_DTD;
      }
    }
  }, {
    key: "sText",
    value: function sText() {
      //
      // We did try a version of saxes where the S_TEXT state was split in two
      // states: one for text inside the root element, and one for text
      // outside. This was avoiding having to test this.tags.length to decide
      // what implementation to actually use.
      //
      // Peformance testing on gigabyte-size files did not show any advantage to
      // using the two states solution instead of the current one. Conversely, it
      // made the code a bit more complicated elsewhere. For instance, a comment
      // can appear before the root element so when a comment ended it was
      // necessary to determine whether to return to the S_TEXT state or to the
      // new text-outside-root state.
      //
      if (this.tags.length !== 0) {
        this.handleTextInRoot();
      } else {
        this.handleTextOutsideRoot();
      }
    }
  }, {
    key: "sEntity",
    value: function sEntity() {
      // This is essentially a specialized version of captureToChar(SEMICOLON...)
      var start = this.i;
      var chunk = this.chunk; // eslint-disable-next-line no-labels, no-restricted-syntax

      loop: // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case NL_LIKE:
            this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
            start = this.i;
            break;

          case SEMICOLON:
            {
              var entityReturnState = this.entityReturnState;
              var entity = this.entity + chunk.slice(start, this.prevI);
              this.state = entityReturnState;
              var parsed = void 0;

              if (entity === "") {
                this.fail("empty entity name.");
                parsed = "&;";
              } else {
                parsed = this.parseEntity(entity);
                this.entity = "";
              }

              if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
                this.text += parsed;
              } // eslint-disable-next-line no-labels


              break loop;
            }

          case EOC:
            this.entity += chunk.slice(start); // eslint-disable-next-line no-labels

            break loop;

          default:
        }
      }
    }
  }, {
    key: "sOpenWaka",
    value: function sOpenWaka() {
      // Reminder: a state handler is called with at least one character
      // available in the current chunk. So the first call to get code inside of
      // a state handler cannot return ``EOC``. That's why we don't test
      // for it.
      var c = this.getCode(); // either a /, ?, !, or text is coming next.

      if (isNameStartChar(c)) {
        this.state = S_OPEN_TAG;
        this.unget();
        this.xmlDeclPossible = false;
      } else {
        switch (c) {
          case FORWARD_SLASH:
            this.state = S_CLOSE_TAG;
            this.xmlDeclPossible = false;
            break;

          case BANG:
            this.state = S_OPEN_WAKA_BANG;
            this.openWakaBang = "";
            this.xmlDeclPossible = false;
            break;

          case QUESTION:
            this.state = S_PI_FIRST_CHAR;
            break;

          default:
            this.fail("disallowed character in tag name");
            this.state = S_TEXT;
            this.xmlDeclPossible = false;
        }
      }
    }
  }, {
    key: "sOpenWakaBang",
    value: function sOpenWakaBang() {
      this.openWakaBang += String.fromCodePoint(this.getCodeNorm());

      switch (this.openWakaBang) {
        case "[CDATA[":
          if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
          }

          if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
          }

          this.state = S_CDATA;
          this.openWakaBang = "";
          break;

        case "--":
          this.state = S_COMMENT;
          this.openWakaBang = "";
          break;

        case "DOCTYPE":
          this.state = S_DOCTYPE;

          if (this.doctype || this.sawRoot) {
            this.fail("inappropriately located doctype declaration.");
          }

          this.openWakaBang = "";
          break;

        default:
          // 7 happens to be the maximum length of the string that can possibly
          // match one of the cases above.
          if (this.openWakaBang.length >= 7) {
            this.fail("incorrect syntax.");
          }

      }
    }
  }, {
    key: "sComment",
    value: function sComment() {
      if (this.captureToChar(MINUS)) {
        this.state = S_COMMENT_ENDING;
      }
    }
  }, {
    key: "sCommentEnding",
    value: function sCommentEnding() {
      var _a;

      var c = this.getCodeNorm();

      if (c === MINUS) {
        this.state = S_COMMENT_ENDED; // eslint-disable-next-line no-unused-expressions

        (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
        this.text = "";
      } else {
        this.text += "-".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      }
    }
  }, {
    key: "sCommentEnded",
    value: function sCommentEnded() {
      var c = this.getCodeNorm();

      if (c !== GREATER) {
        this.fail("malformed comment."); // <!-- blah -- bloo --> will be recorded as
        // a comment of " blah -- bloo "

        this.text += "--".concat(String.fromCodePoint(c));
        this.state = S_COMMENT;
      } else {
        this.state = S_TEXT;
      }
    }
  }, {
    key: "sCData",
    value: function sCData() {
      if (this.captureToChar(CLOSE_BRACKET)) {
        this.state = S_CDATA_ENDING;
      }
    }
  }, {
    key: "sCDataEnding",
    value: function sCDataEnding() {
      var c = this.getCodeNorm();

      if (c === CLOSE_BRACKET) {
        this.state = S_CDATA_ENDING_2;
      } else {
        this.text += "]".concat(String.fromCodePoint(c));
        this.state = S_CDATA;
      }
    }
  }, {
    key: "sCDataEnding2",
    value: function sCDataEnding2() {
      var _a;

      var c = this.getCodeNorm();

      switch (c) {
        case GREATER:
          {
            // eslint-disable-next-line no-unused-expressions
            (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
            this.text = "";
            this.state = S_TEXT;
            break;
          }

        case CLOSE_BRACKET:
          this.text += "]";
          break;

        default:
          this.text += "]]".concat(String.fromCodePoint(c));
          this.state = S_CDATA;
      }
    } // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.

  }, {
    key: "sPIFirstChar",
    value: function sPIFirstChar() {
      var c = this.getCodeNorm(); // This is first because in the case where the file is well-formed this is
      // the branch taken. We optimize for well-formedness.

      if (this.nameStartCheck(c)) {
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      } else if (c === QUESTION || isS(c)) {
        this.fail("processing instruction without a target.");
        this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
      } else {
        this.fail("disallowed character in processing instruction name.");
        this.piTarget += String.fromCodePoint(c);
        this.state = S_PI_REST;
      }
    }
  }, {
    key: "sPIRest",
    value: function sPIRest() {
      // Capture characters into a piTarget while ``this.nameCheck`` run on the
      // character read returns true.
      var chunk = this.chunk,
          start = this.i; // eslint-disable-next-line no-constant-condition

      while (true) {
        var c = this.getCodeNorm();

        if (c === EOC) {
          this.piTarget += chunk.slice(start);
          return;
        } // NL cannot satisfy this.nameCheck so we don't have to test specifically
        // for it.


        if (!this.nameCheck(c)) {
          this.piTarget += chunk.slice(start, this.prevI);
          var isQuestion = c === QUESTION;

          if (isQuestion || isS(c)) {
            if (this.piTarget === "xml") {
              if (!this.xmlDeclPossible) {
                this.fail("an XML declaration must be at the start of the document.");
              }

              this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
            } else {
              this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
            }
          } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
          }

          break;
        }
      }
    }
  }, {
    key: "sPIBody",
    value: function sPIBody() {
      if (this.text.length === 0) {
        var c = this.getCodeNorm();

        if (c === QUESTION) {
          this.state = S_PI_ENDING;
        } else if (!isS(c)) {
          this.text = String.fromCodePoint(c);
        }
      } // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.
      else if (this.captureToChar(QUESTION)) {
          this.state = S_PI_ENDING;
        }
    }
  }, {
    key: "sPIEnding",
    value: function sPIEnding() {
      var _a;

      var c = this.getCodeNorm();

      if (c === GREATER) {
        var piTarget = this.piTarget;

        if (piTarget.toLowerCase() === "xml") {
          this.fail("the XML declaration must appear at the start of the document.");
        } // eslint-disable-next-line no-unused-expressions


        (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
          target: piTarget,
          body: this.text
        });
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else if (c === QUESTION) {
        // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
      } else {
        this.text += "?".concat(String.fromCodePoint(c));
        this.state = S_PI_BODY;
      }

      this.xmlDeclPossible = false;
    }
  }, {
    key: "sXMLDeclNameStart",
    value: function sXMLDeclNameStart() {
      var c = this.skipSpaces(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }

      if (c !== EOC) {
        this.state = S_XML_DECL_NAME;
        this.name = String.fromCodePoint(c);
      }
    }
  }, {
    key: "sXMLDeclName",
    value: function sXMLDeclName() {
      var c = this.captureTo(XML_DECL_NAME_TERMINATOR); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.name += this.text;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (!(isS(c) || c === EQUAL)) {
        return;
      }

      this.name += this.text;
      this.text = "";

      if (!this.xmlDeclExpects.includes(this.name)) {
        switch (this.name.length) {
          case 0:
            this.fail("did not expect any more name/value pairs.");
            break;

          case 1:
            this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
            break;

          default:
            this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
        }
      }

      this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
    }
  }, {
    key: "sXMLDeclEq",
    value: function sXMLDeclEq() {
      var c = this.getCodeNorm(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (isS(c)) {
        return;
      }

      if (c !== EQUAL) {
        this.fail("value required.");
      }

      this.state = S_XML_DECL_VALUE_START;
    }
  }, {
    key: "sXMLDeclValueStart",
    value: function sXMLDeclValueStart() {
      var c = this.getCodeNorm(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (isS(c)) {
        return;
      }

      if (!isQuote(c)) {
        this.fail("value must be quoted.");
        this.q = SPACE;
      } else {
        this.q = c;
      }

      this.state = S_XML_DECL_VALUE;
    }
  }, {
    key: "sXMLDeclValue",
    value: function sXMLDeclValue() {
      var c = this.captureTo([this.q, QUESTION]); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        this.state = S_XML_DECL_ENDING;
        this.text = "";
        this.fail("XML declaration is incomplete.");
        return;
      }

      if (c === EOC) {
        return;
      }

      var value = this.text;
      this.text = "";

      switch (this.name) {
        case "version":
          {
            this.xmlDeclExpects = ["encoding", "standalone"];
            var version = value;
            this.xmlDecl.version = version; // This is the test specified by XML 1.0 but it is fine for XML 1.1.

            if (!/^1\.[0-9]+$/.test(version)) {
              this.fail("version number must match /^1\\.[0-9]+$/.");
            } // When forceXMLVersion is set, the XML declaration is ignored.
            else if (!this.opt.forceXMLVersion) {
                this.setXMLVersion(version);
              }

            break;
          }

        case "encoding":
          if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
            this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
          }

          this.xmlDeclExpects = ["standalone"];
          this.xmlDecl.encoding = value;
          break;

        case "standalone":
          if (value !== "yes" && value !== "no") {
            this.fail("standalone value must match \"yes\" or \"no\".");
          }

          this.xmlDeclExpects = [];
          this.xmlDecl.standalone = value;
          break;

        default: // We don't need to raise an error here since we've already raised one
        // when checking what name was expected.

      }

      this.name = "";
      this.state = S_XML_DECL_SEPARATOR;
    }
  }, {
    key: "sXMLDeclSeparator",
    value: function sXMLDeclSeparator() {
      var c = this.getCodeNorm(); // The question mark character is not valid inside any of the XML
      // declaration name/value pairs.

      if (c === QUESTION) {
        // It is valid to go to S_XML_DECL_ENDING from this state.
        this.state = S_XML_DECL_ENDING;
        return;
      }

      if (!isS(c)) {
        this.fail("whitespace required.");
        this.unget();
      }

      this.state = S_XML_DECL_NAME_START;
    }
  }, {
    key: "sXMLDeclEnding",
    value: function sXMLDeclEnding() {
      var _a;

      var c = this.getCodeNorm();

      if (c === GREATER) {
        if (this.piTarget !== "xml") {
          this.fail("processing instructions are not allowed before root.");
        } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
          this.fail("XML declaration must contain a version.");
        } // eslint-disable-next-line no-unused-expressions


        (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
        this.name = "";
        this.piTarget = this.text = "";
        this.state = S_TEXT;
      } else {
        // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
      }

      this.xmlDeclPossible = false;
    }
  }, {
    key: "sOpenTag",
    value: function sOpenTag() {
      var _a;

      var c = this.captureNameChars();

      if (c === EOC) {
        return;
      }

      var tag = this.tag = {
        name: this.name,
        attributes: Object.create(null)
      };
      this.name = "";

      if (this.xmlnsOpt) {
        this.topNS = tag.ns = Object.create(null);
      } // eslint-disable-next-line no-unused-expressions


      (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      this.sawRoot = true;

      if (!this.fragmentOpt && this.closedRoot) {
        this.fail("documents may contain only one root.");
      }

      switch (c) {
        case GREATER:
          this.openTag();
          break;

        case FORWARD_SLASH:
          this.state = S_OPEN_TAG_SLASH;
          break;

        default:
          if (!isS(c)) {
            this.fail("disallowed character in tag name.");
          }

          this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sOpenTagSlash",
    value: function sOpenTagSlash() {
      if (this.getCode() === GREATER) {
        this.openSelfClosingTag();
      } else {
        this.fail("forward-slash in opening tag not followed by >.");
        this.state = S_ATTRIB;
      }
    }
  }, {
    key: "sAttrib",
    value: function sAttrib() {
      var c = this.skipSpaces();

      if (c === EOC) {
        return;
      }

      if (isNameStartChar(c)) {
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribName",
    value: function sAttribName() {
      var c = this.captureNameChars();

      if (c === EQUAL) {
        this.state = S_ATTRIB_VALUE;
      } else if (isS(c)) {
        this.state = S_ATTRIB_NAME_SAW_WHITE;
      } else if (c === GREATER) {
        this.fail("attribute without value.");
        this.pushAttrib(this.name, this.name);
        this.name = this.text = "";
        this.openTag();
      } else if (c !== EOC) {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribNameSawWhite",
    value: function sAttribNameSawWhite() {
      var c = this.skipSpaces();

      switch (c) {
        case EOC:
          return;

        case EQUAL:
          this.state = S_ATTRIB_VALUE;
          break;

        default:
          this.fail("attribute without value."); // Should we do this???
          // this.tag.attributes[this.name] = "";

          this.text = "";
          this.name = "";

          if (c === GREATER) {
            this.openTag();
          } else if (isNameStartChar(c)) {
            this.unget();
            this.state = S_ATTRIB_NAME;
          } else {
            this.fail("disallowed character in attribute name.");
            this.state = S_ATTRIB;
          }

      }
    }
  }, {
    key: "sAttribValue",
    value: function sAttribValue() {
      var c = this.getCodeNorm();

      if (isQuote(c)) {
        this.q = c;
        this.state = S_ATTRIB_VALUE_QUOTED;
      } else if (!isS(c)) {
        this.fail("unquoted attribute value.");
        this.state = S_ATTRIB_VALUE_UNQUOTED;
        this.unget();
      }
    }
  }, {
    key: "sAttribValueQuoted",
    value: function sAttribValueQuoted() {
      // We deliberately do not use captureTo here. The specialized code we use
      // here is faster than using captureTo.
      var q = this.q,
          chunk = this.chunk;
      var start = this.i; // eslint-disable-next-line no-constant-condition

      while (true) {
        switch (this.getCode()) {
          case q:
            this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
            this.name = this.text = "";
            this.q = null;
            this.state = S_ATTRIB_VALUE_CLOSED;
            return;

          case AMP:
            this.text += chunk.slice(start, this.prevI);
            this.state = S_ENTITY;
            this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
            return;

          case NL:
          case NL_LIKE:
          case TAB:
            this.text += "".concat(chunk.slice(start, this.prevI), " ");
            start = this.i;
            break;

          case LESS:
            this.text += chunk.slice(start, this.prevI);
            this.fail("disallowed character.");
            return;

          case EOC:
            this.text += chunk.slice(start);
            return;

          default:
        }
      }
    }
  }, {
    key: "sAttribValueClosed",
    value: function sAttribValueClosed() {
      var c = this.getCodeNorm();

      if (isS(c)) {
        this.state = S_ATTRIB;
      } else if (c === GREATER) {
        this.openTag();
      } else if (c === FORWARD_SLASH) {
        this.state = S_OPEN_TAG_SLASH;
      } else if (isNameStartChar(c)) {
        this.fail("no whitespace between attributes.");
        this.unget();
        this.state = S_ATTRIB_NAME;
      } else {
        this.fail("disallowed character in attribute name.");
      }
    }
  }, {
    key: "sAttribValueUnquoted",
    value: function sAttribValueUnquoted() {
      // We don't do anything regarding EOL or space handling for unquoted
      // attributes. We already have failed by the time we get here, and the
      // contract that saxes upholds states that upon failure, it is not safe to
      // rely on the data passed to event handlers (other than
      // ``onerror``). Passing "bad" data is not a problem.
      var c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);

      switch (c) {
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
          break;

        case LESS:
          this.fail("disallowed character.");
          break;

        case EOC:
          break;

        default:
          if (this.text.includes("]]>")) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }

          this.pushAttrib(this.name, this.text);
          this.name = this.text = "";

          if (c === GREATER) {
            this.openTag();
          } else {
            this.state = S_ATTRIB;
          }

      }
    }
  }, {
    key: "sCloseTag",
    value: function sCloseTag() {
      var c = this.captureNameChars();

      if (c === GREATER) {
        this.closeTag();
      } else if (isS(c)) {
        this.state = S_CLOSE_TAG_SAW_WHITE;
      } else if (c !== EOC) {
        this.fail("disallowed character in closing tag.");
      }
    }
  }, {
    key: "sCloseTagSawWhite",
    value: function sCloseTagSawWhite() {
      switch (this.skipSpaces()) {
        case GREATER:
          this.closeTag();
          break;

        case EOC:
          break;

        default:
          this.fail("disallowed character in closing tag.");
      }
    } // END OF STATE ENGINE METHODS

  }, {
    key: "handleTextInRoot",
    value: function handleTextInRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for performing the ]]> check. A previous version of this code, checked
      // ``this.text`` for the presence of ]]>. It simplified the code but was
      // very costly when character data contained a lot of entities to be parsed.
      //
      // Since we are using a specialized loop, we also keep track of the presence
      // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
      //
      var start = this.i,
          forbiddenState = this.forbiddenState;
      var chunk = this.chunk,
          handler = this.textHandler; // eslint-disable-next-line no-labels, no-restricted-syntax

      scanLoop: // eslint-disable-next-line no-constant-condition
      while (true) {
        switch (this.getCode()) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;

              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);

                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              }

              forbiddenState = FORBIDDEN_START; // eslint-disable-next-line no-labels

              break scanLoop;
            }

          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;

            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }

            forbiddenState = FORBIDDEN_START; // eslint-disable-next-line no-labels

            break scanLoop;

          case CLOSE_BRACKET:
            switch (forbiddenState) {
              case FORBIDDEN_START:
                forbiddenState = FORBIDDEN_BRACKET;
                break;

              case FORBIDDEN_BRACKET:
                forbiddenState = FORBIDDEN_BRACKET_BRACKET;
                break;

              case FORBIDDEN_BRACKET_BRACKET:
                break;

              default:
                throw new Error("impossible state");
            }

            break;

          case GREATER:
            if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
              this.fail("the string \"]]>\" is disallowed in char data.");
            }

            forbiddenState = FORBIDDEN_START;
            break;

          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }

            start = this.i;
            forbiddenState = FORBIDDEN_START;
            break;

          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            } // eslint-disable-next-line no-labels


            break scanLoop;

          default:
            forbiddenState = FORBIDDEN_START;
        }
      }

      this.forbiddenState = forbiddenState;
    }
  }, {
    key: "handleTextOutsideRoot",
    value: function handleTextOutsideRoot() {
      // This is essentially a specialized version of captureTo which is optimized
      // for a specialized task. We keep track of the presence of non-space
      // characters in the text since these are errors when appearing outside the
      // document root element.
      var start = this.i;
      var chunk = this.chunk,
          handler = this.textHandler;
      var nonSpace = false; // eslint-disable-next-line no-labels, no-restricted-syntax

      outRootLoop: // eslint-disable-next-line no-constant-condition
      while (true) {
        var code = this.getCode();

        switch (code) {
          case LESS:
            {
              this.state = S_OPEN_WAKA;

              if (handler !== undefined) {
                var text = this.text;
                var slice = chunk.slice(start, this.prevI);

                if (text.length !== 0) {
                  handler(text + slice);
                  this.text = "";
                } else if (slice.length !== 0) {
                  handler(slice);
                }
              } // eslint-disable-next-line no-labels


              break outRootLoop;
            }

          case AMP:
            this.state = S_ENTITY;
            this.entityReturnState = S_TEXT;

            if (handler !== undefined) {
              this.text += chunk.slice(start, this.prevI);
            }

            nonSpace = true; // eslint-disable-next-line no-labels

            break outRootLoop;

          case NL_LIKE:
            if (handler !== undefined) {
              this.text += "".concat(chunk.slice(start, this.prevI), "\n");
            }

            start = this.i;
            break;

          case EOC:
            if (handler !== undefined) {
              this.text += chunk.slice(start);
            } // eslint-disable-next-line no-labels


            break outRootLoop;

          default:
            if (!isS(code)) {
              nonSpace = true;
            }

        }
      }

      if (!nonSpace) {
        return;
      } // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
      // to avoid reporting errors for every single character that is out of
      // place.


      if (!this.sawRoot && !this.reportedTextBeforeRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextBeforeRoot = true;
      }

      if (this.closedRoot && !this.reportedTextAfterRoot) {
        this.fail("text data outside of root node.");
        this.reportedTextAfterRoot = true;
      }
    }
  }, {
    key: "pushAttribNS",
    value: function pushAttribNS(name, value) {
      var _a;

      var _this$qname = this.qname(name),
          prefix = _this$qname.prefix,
          local = _this$qname.local;

      var attr = {
        name: name,
        prefix: prefix,
        local: local,
        value: value
      };
      this.attribList.push(attr); // eslint-disable-next-line no-unused-expressions

      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);

      if (prefix === "xmlns") {
        var trimmed = value.trim();

        if (this.currentXMLVersion === "1.0" && trimmed === "") {
          this.fail("invalid attempt to undefine prefix in XML 1.0");
        }

        this.topNS[local] = trimmed;
        nsPairCheck(this, local, trimmed);
      } else if (name === "xmlns") {
        var _trimmed = value.trim();

        this.topNS[""] = _trimmed;
        nsPairCheck(this, "", _trimmed);
      }
    }
  }, {
    key: "pushAttribPlain",
    value: function pushAttribPlain(name, value) {
      var _a;

      var attr = {
        name: name,
        value: value
      };
      this.attribList.push(attr); // eslint-disable-next-line no-unused-expressions

      (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */

  }, {
    key: "end",
    value: function end() {
      var _a, _b;

      if (!this.sawRoot) {
        this.fail("document must contain a root element.");
      }

      var tags = this.tags;

      while (tags.length > 0) {
        var tag = tags.pop();
        this.fail("unclosed tag: ".concat(tag.name));
      }

      if (this.state !== S_BEGIN && this.state !== S_TEXT) {
        this.fail("unexpected end.");
      }

      var text = this.text;

      if (text.length !== 0) {
        // eslint-disable-next-line no-unused-expressions
        (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
        this.text = "";
      }

      this._closed = true; // eslint-disable-next-line no-unused-expressions

      (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);

      this._init();

      return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */

  }, {
    key: "resolve",
    value: function resolve(prefix) {
      var _a, _b;

      var uri = this.topNS[prefix];

      if (uri !== undefined) {
        return uri;
      }

      var tags = this.tags;

      for (var index = tags.length - 1; index >= 0; index--) {
        uri = tags[index].ns[prefix];

        if (uri !== undefined) {
          return uri;
        }
      }

      uri = this.ns[prefix];

      if (uri !== undefined) {
        return uri;
      }

      return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */

  }, {
    key: "qname",
    value: function qname(name) {
      // This is faster than using name.split(":").
      var colon = name.indexOf(":");

      if (colon === -1) {
        return {
          prefix: "",
          local: name
        };
      }

      var local = name.slice(colon + 1);
      var prefix = name.slice(0, colon);

      if (prefix === "" || local === "" || local.includes(":")) {
        this.fail("malformed name: ".concat(name, "."));
      }

      return {
        prefix: prefix,
        local: local
      };
    }
  }, {
    key: "processAttribsNS",
    value: function processAttribsNS() {
      var _a;

      var attribList = this.attribList;
      var tag = this.tag;
      {
        // add namespace info to tag
        var _this$qname2 = this.qname(tag.name),
            prefix = _this$qname2.prefix,
            local = _this$qname2.local;

        tag.prefix = prefix;
        tag.local = local;
        var uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";

        if (prefix !== "") {
          if (prefix === "xmlns") {
            this.fail("tags may not have \"xmlns\" as prefix.");
          }

          if (uri === "") {
            this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
            tag.uri = prefix;
          }
        }
      }

      if (attribList.length === 0) {
        return;
      }

      var attributes = tag.attributes;
      var seen = new Set(); // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting

      var _iterator = _createForOfIteratorHelper(attribList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var name = attr.name,
              _prefix = attr.prefix,
              _local = attr.local;

          var _uri = void 0;

          var eqname = void 0;

          if (_prefix === "") {
            _uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
            eqname = name;
          } else {
            _uri = this.resolve(_prefix); // if there's any attributes with an undefined namespace,
            // then fail on them now.

            if (_uri === undefined) {
              this.fail("unbound namespace prefix: ".concat(JSON.stringify(_prefix), "."));
              _uri = _prefix;
            }

            eqname = "{".concat(_uri, "}").concat(_local);
          }

          if (seen.has(eqname)) {
            this.fail("duplicate attribute: ".concat(eqname, "."));
          }

          seen.add(eqname);
          attr.uri = _uri;
          attributes[name] = attr;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.attribList = [];
    }
  }, {
    key: "processAttribsPlain",
    value: function processAttribsPlain() {
      var attribList = this.attribList; // eslint-disable-next-line prefer-destructuring

      var attributes = this.tag.attributes;

      var _iterator2 = _createForOfIteratorHelper(attribList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
              name = _step2$value.name,
              value = _step2$value.value;

          if (attributes[name] !== undefined) {
            this.fail("duplicate attribute: ".concat(name, "."));
          }

          attributes[name] = value;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */

  }, {
    key: "openTag",
    value: function openTag() {
      var _a;

      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = false; // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions

      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
      tags.push(tag);
      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */

  }, {
    key: "openSelfClosingTag",
    value: function openSelfClosingTag() {
      var _a, _b, _c;

      this.processAttribs();
      var tags = this.tags;
      var tag = this.tag;
      tag.isSelfClosing = true; // There cannot be any pending text here due to the onopentagstart that was
      // necessarily emitted before we get here. So we do not check text.
      // eslint-disable-next-line no-unused-expressions

      (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag); // eslint-disable-next-line no-unused-expressions

      (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
      var top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;

      if (top === null) {
        this.closedRoot = true;
      }

      this.state = S_TEXT;
      this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */

  }, {
    key: "closeTag",
    value: function closeTag() {
      var tags = this.tags,
          name = this.name; // Our state after this will be S_TEXT, no matter what, and we can clear
      // tagName now.

      this.state = S_TEXT;
      this.name = "";

      if (name === "") {
        this.fail("weird empty close tag.");
        this.text += "</>";
        return;
      }

      var handler = this.closeTagHandler;
      var l = tags.length;

      while (l-- > 0) {
        var tag = this.tag = tags.pop();
        this.topNS = tag.ns; // eslint-disable-next-line no-unused-expressions

        handler === null || handler === void 0 ? void 0 : handler(tag);

        if (tag.name === name) {
          break;
        }

        this.fail("unexpected close tag.");
      }

      if (l === 0) {
        this.closedRoot = true;
      } else if (l < 0) {
        this.fail("unmatched closing tag: ".concat(name, "."));
        this.text += "</".concat(name, ">");
      }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */

  }, {
    key: "parseEntity",
    value: function parseEntity(entity) {
      // startsWith would be significantly slower for this test.
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      if (entity[0] !== "#") {
        var defined = this.ENTITIES[entity];

        if (defined !== undefined) {
          return defined;
        }

        this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
        return "&".concat(entity, ";");
      }

      var num = NaN;

      if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
        num = parseInt(entity.slice(2), 16);
      } else if (/^#[0-9]+$/.test(entity)) {
        num = parseInt(entity.slice(1), 10);
      } // The character reference is required to match the CHAR production.


      if (!this.isChar(num)) {
        this.fail("malformed character entity.");
        return "&".concat(entity, ";");
      }

      return String.fromCodePoint(num);
    }
  }, {
    key: "closed",
    get: function get() {
      return this._closed;
    }
  }, {
    key: "position",
    get: function get() {
      return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */

  }, {
    key: "columnIndex",
    get: function get() {
      return this.position - this.positionAtNewLine;
    }
  }]);

  return SaxesParser;
}();

exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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